import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import CategoryTabs from '@/components/feature/CategoryTabs';
import { categories, getCategoryById } from '@/mocks/categories';
import { getArticlesByCategory, articles } from '@/mocks/articles';

export default function Category() {
  const { categoryId } = useParams<{ categoryId: string }>();
  const { t } = useTranslation();

  const category = categoryId && categoryId !== 'all' ? getCategoryById(categoryId) : null;
  const displayArticles = categoryId === 'all' || !categoryId
    ? articles
    : getArticlesByCategory(categoryId);

  const breadcrumbItems = [
    { label: t('breadcrumbHome'), href: '/' },
  ];

  if (category) {
    breadcrumbItems.push({ label: category.name });
  } else {
    breadcrumbItems.push({ label: t('allCategories') });
  }

  const pageTitle = category ? category.name : t('allCategories');
  const pageDescription = category ? category.description : '按摩视频教程全部分类，涵盖全身放松、肩颈按摩、腰背按摩、穴位按摩教学、足底反射区和头部按摩等专业教程';

  return (
    <>
      <Navbar />
      <ScrollToTop />

      <main className="pt-20">
        <div className="bg-background-100">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={breadcrumbItems} />

            <div className="px-4 md:px-6 py-10 md:py-14">
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
                {pageTitle}
              </h1>
              {category && (
                <p className="text-sm md:text-base text-foreground-500 max-w-2xl">
                  {category.description}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <CategoryTabs categories={categories} activeId={categoryId} />
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 pb-14 md:pb-20">
          {displayArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {displayArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-4">
                <i className="ri-file-search-line text-2xl"></i>
              </div>
              <p className="text-foreground-500">{t('noArticles')}</p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}